import {getDate, getKeyTitle} from "../js/tool";
import {getShowFileList} from "../js/file";
import {getStorageInfo} from "../js/storage";

export const activityStatusList = [
    {key: 1, title: "未开始"},
    {key: 2, title: "进行中"},
    {key: 3, title: "已结束"},
    {key: 4, title: "创建中"},
]

export const activityFormItems = [
    {
        key: 'name',
        label: '活动名称',
        component: 'a-input',
        props: {
            placeholder: '请输入活动名称',
        },
        rules: [{ required: true, message: '请输入活动名称', trigger: 'blur' }]
    },
    {
        key: 'name_en',
        label: '活动英文名称',
        component: 'a-input',
        props: {
            placeholder: '请输入活动英文名称',
        },
        rules: [{ required: true, message: '请输入活动英文名称', trigger: 'blur' }]
    },
    {
        key: 'time',
        label: '活动时间',
        component: 'a-range-picker',
        props: {
            format: 'YYYY-MM-DD',
            valueFormat: 'YYYY-MM-DD',
            placeholder: ['开始时间', '截止时间']
        },
        rules: [{ required: true, message: '请设置活动时间', trigger: 'change' }]
    },
    {
        key: 'address',
        label: '活动地点',
        component: 'a-input',
        props: {
            placeholder: '请输入活动地点',
        },
        rules: [{ required: true, message: '请输入活动地点', trigger: 'blur' }]
    },
    {
        key: 'address_en',
        label: '活动地点英文',
        component: 'a-input',
        props: {
            placeholder: '请输入活动地点英文',
        },
        rules: [{ required: true, message: '请输入活动地点英文', trigger: 'blur' }]
    },
    {
        key: 'people_count',
        label: '活动人数',
        component: 'a-input-number',
        props: {
            placeholder: '请输入活动人数',
        },
        style: {
            width: '100%'
        },
        rules: [{ required: true, message: '请输入容纳人数', trigger: 'change' }]
    },
    {
        key: 'cover',
        label: '活动封面',
        component: 'form-upload',
        props: {
            limit: 1
        },
    },
    {
        key: 'files',
        label: '活动文件',
        component: 'file-upload',
        props: {
            limit: -1
        },
    },
    {
        key: 'info',
        label: '活动介绍',
        component: 'rich-editor',
        props: {
            placeholder: '请输入活动介绍'
        },
    },
    {
        key: 'info_en',
        label: '活动英文介绍',
        component: 'rich-editor',
        props: {
            placeholder: '请输入活动英文介绍'
        },
    }
];

export const getEditActivityForm = function (activityId) {
    const items = [...activityFormItems];
    const index = items.findIndex(c => c.key == 'people_count');
    if(index >= 0) {
        const others = [
            {
                key: 'chargeUser',
                label: '统筹人',
                component: 'select-person',
                props: {
                    activity: activityId,
                    type: 2,
                    uniqueKey: "tel"
                },
                rules: [{ required: true, message: '请设置活动统筹人', trigger: 'change' }]
            },
            {
                key: 'chargeGroup',
                label: '统筹小组',
                component: 'select-person',
                props: {
                    activity: activityId,
                    type: 2,
                    uniqueKey: "tel",
                    multiple: true
                },
            },
        ];
        items.splice(index, 0, ...others)
    }
    return items;
}

export const getActivityStatus = function (activity) {
    return getKeyTitle(activityStatusList, activity.status);
}

export const getActivityShowTime = function (activity) {
    let res = '';
    if(activity) {
        const {start_time, end_time} = activity;
        res = `${getDate(start_time).pattern("yyyy年M月d日")} 至 ${getDate(end_time).pattern("yyyy年M月d日")}`;
    }
    return res;
}

export const getProgressPercent = function(progress) {
    return progress && progress.all > 0 ? (progress.done / progress.all * 100).toFixed(2) * 1 : 0;
}

export const dealActivity = function (activity) {
    activity.statusText = getActivityStatus(activity);
    activity.detailList = [
        {label: '活动名称', value: activity.name},
        {label: '活动地点', value: activity.address},
        {label: '活动时间', value: getActivityShowTime(activity)},
        {label: '活动人数', value: activity.people_count ? `${activity.people_count}人` : '未设置' },
        {label: '官方文件', value: getShowFileList(activity.file), file: true, full: true},
    ]
}

/* 当前用户是否是小组组长 */
export const isLeader = function (group) {
    let res = null;
    const user = getStorageInfo();
    if(user && group && group.leader) {
        const p = group.leader.find(l => l.tel == user.tel);
        if (p) {
            res = p;
        }
    }
    return res;
}

/* 当前用户是否是任务成员 */
export const isMember = function(task) {
    let res = null;
    const user = getStorageInfo();
    if(user && task && task.user) {
        const p = task.user.find(u => u.tel == user.tel);
        if (p) {
            res = p;
        }
    }
    return res;
}

const setIds = function(list, ids) {
    if(ids) {
        ids = ids.split(",");
        ids.forEach(id => {
            if(list.indexOf(id) === -1) {
                list.push(id);
            }
        })
    }
}

export const getActivityModuleIds = function (activity) {
    let moduleIds = activity.moduleIds;
    if(!moduleIds) {
        moduleIds = [];
        if (activity.chargeGroup && activity.chargeGroup.length > 0) {
            activity.chargeGroup.forEach(g => {
                if(g.task && g.task.length > 0) {
                    g.task.forEach(t => setIds(moduleIds, t.module_ids))
                }
            });
        }
        if (activity.chargeTask && activity.chargeTask.length > 0) {
            activity.chargeTask.forEach(t => {
                setIds(moduleIds, t.module_ids);
            });
        }
        activity.moduleIds = moduleIds;
    }
    return moduleIds
}

/**
 * 生成活动的日期日程数组
 * @param activity
 * @return {[]}
 */

export const generateDaySchList = function (activity) {
    const res = [];
    if(activity && activity.start_time && activity.end_time) {
        let start = getDate(activity.start_time).getTime();
        const end = getDate(activity.end_time).getTime();
        const day = 86400000;
        do {
            const date = new Date(start).pattern("yyyy-MM-dd");
            res.push({
                date,
                list: []
            });
            start += day;
        } while (start <= end)
    }
    return res;
}

/**
 * 将日程数组处理成按照天展示的列表
 * @param activity 活动实体
 * @param schList 活动日程列表
 * @param create 是否是创建活动
 */
export const getActivityDayList = function (activity, schList, create) {
    const list = generateDaySchList(activity);
    if(schList && schList.length > 0) {
        schList.forEach(item => {
            const start = getDate(item.start_time);
            const date = start.pattern("yyyy-MM-dd");
            let time = start.pattern("HH:mm");
            create && (item.startTime = time);
            if (item.end_time) {
                const endTime = getDate(item.end_time).pattern("HH:mm");
                time += ` - ${endTime}`;
                create && (item.endTime = endTime);
            }
            item.showTime = time;
            const day = list.find(d => d.date == date);
            if(day) {
                day.list.push(item);
            } else {
                list.push({
                    date,
                    list: [item]
                })
            }
        });
    }
    // 不是创建活动则计算当日日程进度
    if(!create) {
        list.forEach(day => {
            if(day.list && day.list.length > 0) {
                let all = 0, done = 0;
                day.list.forEach(sch => {
                    if(sch.progress) {
                        all += sch.progress.all * 1;
                        done += sch.progress.done * 1;
                    }
                });
                day.per = getProgressPercent({all, done});
            }
        })
    }
    return list
}
